import type { List } from '@gonfalon/immutable-shim/immutableShim';
import { Record } from '@gonfalon/immutable-shim/immutableShim';
import nullthrows from 'nullthrows';

export interface ReleasePhaseConfigProps {
  randomizationUnit?: string;
  monitoringWindowMilliseconds: number;
  rolloutWeight: number;
  /* Stages and metrics are only available in V2 */
  stages?: List<{
    rolloutWeight: number;
    monitoringWindowMilliseconds: number;
  }>;
  metrics?: List<{
    metricKey: string;
    regressionThreshold?: number;
    unit?: string;
    analysisUnit?: string;
    onRegression: {
      notify: boolean;
      rollback: boolean;
    };
  }>;
  metricSources?: List<{
    key: string;
    isGroup: boolean;
  }>;
}

export class ReleasePhaseConfig extends Record<ReleasePhaseConfigProps>({
  randomizationUnit: undefined,
  monitoringWindowMilliseconds: 0,
  rolloutWeight: 0,
  stages: undefined,
  metrics: undefined,
  metricSources: undefined,
}) {
  toRep() {
    const rep = this.toJSON();
    return {
      ...rep,
      randomizationUnit: nullthrows(rep.randomizationUnit, 'randomizationUnit is required'),
    };
  }
}
